export function isPopulatedMessage(entry) {
  return (
    entry &&
    typeof entry === "object" &&
    !Array.isArray(entry) &&
    (Object.prototype.hasOwnProperty.call(entry, "message") ||
      Object.prototype.hasOwnProperty.call(entry, "image"))
  );
}

export function hydratedThread(raw) {
  if (!Array.isArray(raw)) return [];
  return raw.filter(isPopulatedMessage);
}

export function inOrder(thread) {
  const list = [...(thread || [])];
  return list.sort((a, b) => {
    const ta = a?.createdAt ? new Date(a.createdAt).getTime() : NaN;
    const tb = b?.createdAt ? new Date(b.createdAt).getTime() : NaN;
    if (Number.isFinite(ta) && Number.isFinite(tb) && ta !== tb) return ta - tb;
    if (Number.isFinite(ta) && !Number.isFinite(tb)) return -1;
    if (!Number.isFinite(ta) && Number.isFinite(tb)) return 1;
    return 0;
  });
}

export function mergeThread(existing, incoming) {
  const next = [...(existing || [])];
  for (const msg of incoming || []) {
    if (!isPopulatedMessage(msg)) continue;
    if (msg._id && next.some((m) => m._id === msg._id)) continue;
    const pendingIdx = next.findIndex(
      (m) =>
        m.pending &&
        m.message === msg.message &&
        (!msg._id || m._id === msg._id),
    );
    if (pendingIdx >= 0) {
      next[pendingIdx] = { ...msg, pending: false };
      continue;
    }
    if (
      !msg._id &&
      next.some((m) => m.message === msg.message && m.account === msg.account)
    ) {
      continue;
    }
    next.push(msg);
  }
  return inOrder(next);
}

export function savedOrEcho(resData, typedMessage, accountId) {
  const raw = resData?.data ?? resData;
  let saved = raw;
  if (Array.isArray(raw)) saved = raw[0];
  if (saved && typeof saved === "object" && (saved.message || saved.image)) {
    return saved;
  }
  return {
    message: typedMessage,
    account: accountId,
    createdAt: new Date().toISOString(),
    pending: true,
  };
}
